import { formatNumber, formatPercent } from '@angular/common';
import Formatacao from '../models/types/formatacao';

export const somaValoresDePropriedadeDeObjetos = <T extends object>(objeto: T, propriedade: keyof T): number => {
    return objeto
        ? Object.values(objeto)
              .filter((obj) => typeof obj === 'object')
              .map((obj) => obj[propriedade])
              .map((valor) => (valor ? valor : 0))
              .reduce((acc, valor) => acc + valor, 0)
        : 0;
};

export const somaValoresDePropriedadeDeObjetosS = <T extends object>(objeto: T, propriedade: string): number => {
    return objeto
        ? Object.values(objeto)
              .filter((obj) => typeof obj === 'object')
              .map((obj) => obj[propriedade])
              .map((valor) => (valor ? valor : 0))
              .reduce((acc, valor) => acc + valor, 0)
        : 0;
};

export const transporMatriz = <T extends object>(matriz: T[][]): T[][] => {
    return matriz && matriz.length > 0 ? matriz[0].map((_, colIndex) => matriz.map((row) => row[colIndex])) : [];
};

export const carregaSVG = async (nome: string, fonteImagem: string): Promise<string | null> => {
    const response = await fetch(fonteImagem + nome);
    return response.ok ? await response.text() : null;
};

export const navegaAoTopo = (): void => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

export const calculaOcupacaoTela = (elemento: HTMLElement): number => {
    const rect = elemento.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    const visivel = Math.max(0, Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0));
    const divisor = Math.min(rect.height, windowHeight);

    return divisor > 0 ? visivel / divisor : 0;
};

export function formatarNumero(valor: number, tipo: Formatacao) {
    switch (tipo) {
        case 'porcentagem':
            return formatPercent(valor, 'pt', '1.1-1');
        case 'absolutoInteiro':
            return formatNumber(valor, 'pt', '1.0-0');
        case 'absolutoDecimal':
            return formatNumber(valor, 'pt', '1.1-1');
        case 'dinheiro':
            return `R$${formatNumber(valor, 'pt', '1.0-0')}`;
    }
}
